import { gql } from '@apollo/client';

export const MY_PROJECTS = gql`
  query MyProjects {
    myProjects {
      id
      ownerId
      name
      status
      meta
      users {
        id
        email
        name
        role
      }
      phases {
        id
        projectId
        name
        type
        progress
        sequence
        locked
        status
        isActive
        isHidden
        meta
        data
        users {
          id
          email
          name
          role
        }
        notes {
          id
          text
          createdAt
          authorId
        }
      }
    }
  }
`;

export const PROJECT = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      ownerId
      name
      status
      meta
      users {
        id
        email
        name
        role
      }
      phases {
        id
        projectId
        name
        type
        progress
        sequence
        locked
        status
        isActive
        isHidden
        meta
        data
        users {
          id
          email
          name
          role
        }
        notes {
          id
          text
          createdAt
          authorId
        }
      }
    }
  }
`;
